module.exports = __webpack_public_path__ + "img/music_lover.5df7a1cd.svg";